<template>
    <el-container>
        <el-aside width="200px">
            <sidebar></sidebar>
        </el-aside>
        <el-container>
            <el-header>
				<div class="tools">
					<el-badge class="item">
						<a href="javascript:;" @click="createXml">
							<i class="el-icon-map-location"></i>生成站点地图
						</a>
					</el-badge>
					<el-dropdown @command="handleCommand" trigger="click">
						<span class="el-dropdown-link" v-if="member">
							您好，{{member.username ? member.username : '游客'}}<i class="el-icon-arrow-down"></i>
						</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="/info"><i class="el-icon-user"></i> 个人信息</el-dropdown-item>
							<el-dropdown-item command="2"><i class="el-icon-document"></i> 接口文档</el-dropdown-item>
							<el-dropdown-item command="3"><i class="el-icon-phone-outline"></i> 技术支持</el-dropdown-item>
							<el-dropdown-item command="4" divided><i class="iconfont icon-exit"></i> 退出系统</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
			</el-header>
            <el-main>
                <router-view/>
            </el-main>
        </el-container>
    </el-container>
</template>
<script>
    import sidebar from '@/components/sidebar'
	import {mapState,mapMutations} from 'vuex';
	import { ajax_logout,sitemapCreate } from '@/utils/getData';
	import { setStore } from '@/utils/';
    export default{
        name:'home',
        components:{
            sidebar
        },
		computed:{
            ...mapState([
                'member'
            ])
        },
		methods:{
			...mapMutations([
				'SETMEMBER'
			]),
			async logout(){//退出用户
				const res  = await ajax_logout();
				if(res.code == 0){
					this.$message({
						showClose:true,
						message:'退出成功',
						type:'success'
					});
					setStore("member",{});
					this.SETMEMBER({});
					this.$router.push('/');
				}
			},
			goDashboard(){
				this.$router.push('/dashboard');
			},
			handleCommand(command) {
				if(command == 2){
					window.location.href = 'https://www.showdoc.cc/eggweb';
				}else if(command == 3){
					this.$alert('电话：18750290878， QQ：442774948', '技术支持',{
						type:'info',
						center: true
					});
				}else if(command == 4){
					this.logout();
				}else{
					this.$router.push(command);
				}
			},
			async createXml(){
				const res  = await sitemapCreate();
				if(res.code == 0){
					this.$message({
						showClose:true,
						message:'生成成功',
						type:'success'
					});
				}
			}
		}
    }
</script>
<style scoped>
	.el-header{background: #fff;}
    .el-container{height: 100%;background: #eee;}
    .el-main{overflow: auto;padding: 0;margin:10px;position: relative;}
    .el-aside{background-color: #2C3031;overflow-x: hidden;}

	.tools{float:right;padding-top:18px;font-size:14px;line-height:20px;}
	.tools .item{margin-right:40px;}
	.tools .item i{padding-right:3px;font-size:16px;}
	.tools .item a{display:block;color:#606266;display:flex;align-items: center;text-decoration:none;}
	.tools .item a:hover{color:#1876EF;}
	.el-dropdown-menu__item i{font-size:16px;}
</style>